export interface HubStoreImageQueueRow {
  styleNumber: string;
  skuCode: string;
  barcode: string;
  shelf: string;
  size: string;
  brand: string;
  category: string;
  subCategory: string;
  productType: string;
}

export const hubStoreImageQueueRequest = ({ facilityId }: { facilityId: number }) => ({
  method: 'GET' as const,
  url: '/hub/store-image-queue',
  params: { facilityId },
});
